import { findMessage } from '@bimser/components';
import IconAdd from '@bimser/icons/16/add';
import IconExportToExcell from '@bimser/icons/16/export-to-excel';
import IconFilterClear from '@bimser/icons/16/filter-clear';
import IconRefresh from '@bimser/icons/16/refresh';
import IconRevertAll from '@bimser/icons/16/revert-all';
import IconSave from '@bimser/icons/16/save';
import IconToolEraser from '@bimser/icons/16/tools-eraser';
import DataGrid2 from '..';

export const generateToolbarButtonOptions = (dataGrid: DataGrid2) => ({
	exportButtonOptions: {
		icon: IconExportToExcell.info.getElement()
	},
	saveButtonOptions: {
		icon: IconSave.info.getElement()
	},
	revertButtonOptions: {
		icon: IconRevertAll.info.getElement()
	},
	addRowButtonOptions: {
		icon: IconAdd.info.getElement(),
		onClick: async () => {
			const instance = dataGrid.__bcDataGridRef.current.instance();

			if (instance.hasEditData()) {
				await instance.saveEditData();
				await new Promise<void>(res => setTimeout(() => res(), 100));
			}

			await instance.addRow();
		}
	},
	clearAllOptions: {
		icon: IconToolEraser.info.getElement(),
		text: findMessage.get('102803'),
		hint: findMessage.get('102803'),
		onClick: _ => {
			dataGrid.__bcDataGridRef.current.instance().clearFilter();
			dataGrid.__bcDataGridRef.current.instance().clearSorting();
			dataGrid.__bcDataGridRef.current.instance().clearGrouping();

			dataGrid.columns.forEach(column => {
				if (column.visible) {
					dataGrid.__bcDataGridRef.current
						.instance()
						.columnOption(column.name, 'visible', true);
				}
			});
		}
	},
	filterClearOptions: {
		icon: IconFilterClear.info.getElement(),
		text: findMessage.get('100918'),
		hint: findMessage.get('100918'),
		onClick: _ => {
			dataGrid.__bcDataGridRef.current.instance().clearFilter();
		}
	},
	forceRefreshOptions: {
		icon: IconRefresh.info.getElement(),
		text: findMessage.get('100025'),
		hint: findMessage.get('100025'),
		onClick: _ => {
			dataGrid.reload(true);
		}
	}
});
